module.exports = __webpack_public_path__ + "img/lyricly.jpg_w545.b7e88d47.jpg";